export const ruleRequired = (v) => (Array.isArray(v) ? v.length > 0 : !!v)

export const ruleVerifyVideo = (v) => {
	const vimeo = /(?:https?:\/\/)?(?:www\.)?vimeo\.com\/(?:video\/)?(\d+)/
	const youtube =
		/(?:https?:\/\/)?(?:www\.)?(?:youtube\.com|youtu\.be)\/(?:watch\?v=|v\/|embed\/)?([\w-]+)/
	return v ? vimeo.test(v) || youtube.test(v) : false
}

export const rulePassword = (v) => {
	return !v || v.length >= 5 || (/[0-9]/.test(v) && /[a-zA-Z]/.test(v))
}

export const ruleEmail = (v) =>
	!v ||
	/^(?:[a-zA-Z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b-\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:25[0-5]|2[0-4]\d|[01]?\d{1,2})\.){3}(?:25[0-5]|2[0-4]\d|[01]?\d{1,2}|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b-\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])$/.test(
		v
	)

export const ruleEmailOrDigits = (v) => {
	if (!v) return false
	const val = String(v).trim()
	return /^\d+$/.test(val) || ruleEmail(val)
}

export const ruleLatitude = (v) => !v || (isFinite(v) && Math.abs(v) <= 90)
export const ruleLongitude = (v) => !v || (isFinite(v) && Math.abs(v) <= 180)

export const ruleNotEmpty = (v) => !v || v.trim().length > 0
